import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#223773',
        secondary: '#727c99',
        anchor: '#c92127',
      },
    },
  },
  icons: {
    iconfont: 'mdi',
  },
});
